<template>
  <a-layout-content class="p-all">
    <a-spin :spinning="loading.page">

      <a-row :gutter="[16, 16]" :style="rowStyle">
        <a-col :xs="24" :lg="16">
          <a-card class="manifest-card" style="height: 100%;">
            <div slot="title">
              <span class="d-block">Manifest Klaim Kesehatan</span>
            </div>
            <a-popover slot="extra" trigger="focus" placement="bottomRight">
              <span slot="title">Pilih aksi</span>
              <ul class="list-wrapper bordered" slot="content">
                <li v-if="manifest_hdr.status == 'Revised' && revise_action">
                  <a-button type="danger" class="w-full" icon="edit" @click="reviseAction">
                    Ubah Data
                  </a-button>
                </li>
                <li>
                  <a-button size="default" class="w-full" @click="handlePrint" slot="extra" icon="printer"
                    :loading="loading.print">Print Manifest</a-button>
                </li>
              </ul>
              <a-button icon="more" id="buttonAksi">Aksi</a-button>
            </a-popover>

            <ul class="list-wrapper bordered">
              <li>
                <span class="list-title" for>Nomor Klaim</span>
                <span class="list-desc">{{ manifest_hdr ? manifest_hdr.no_klaim : '' }}</span>
              </li>
              <li>
                <span class="list-title" for>Nama Anggota Keluarga</span>
                <span class="list-desc">{{ manifest_hdr ? (manifest_hdr.nama_member ? manifest_hdr.nama_member :
                  manifest_hdr.nama) : '' }}</span>
              </li>
              <li>
                <span class="list-title" for>Status Hubungan Dalam Keluarga</span>
                <span class="list-desc">{{ manifest_hdr ? manifest_hdr.jenis : '' }}</span>
              </li>
              <li>
                <span class="list-title" for>Total Klaim</span>
                <span class="list-desc">{{ manifest_hdr ? formatRupiah(manifest_hdr.total_klaim) : '' }}</span>
              </li>
              <li>
                <span class="list-title" for>Total Klaim Bayar</span>
                <span class="list-desc">{{ manifest_hdr ? formatRupiah(manifest_hdr.total_nilai_klaim_appr) : '' }}</span>
              </li>
            </ul>

          </a-card>
        </a-col>

        <a-col :xs="24" :lg="8">
          <a-collapse activeKey="1" forceRender style="height: 100%;">
            <a-collapse-panel key="1">
              <!-- header panel -->
              <div class="d-flex justify-between align-middle" slot="header">
                <h4 class="margin-remove">Status</h4>
                <div>
                  <H-Status :status="manifest_hdr.status" />
                  <a-tooltip placement="topRight">
                    <a-button @click="e => { e.stopPropagation(); showHistory(); }" type="default" size="small">
                      <a-icon type="history" />
                    </a-button>
                  </a-tooltip>
                </div>
              </div>
              <!-- content -->
              <a-timeline class="m-timeline">
                <a-timeline-item v-for="sts in manifest_status" color="grey" :key="sts.id_status">
                  <div class="m-timeline-title">{{ sts.actor }} - {{ sts.tlc }}</div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">{{ sts.tanggal_aksi }}</h4>
                    <span class="m-text-small" v-if="sts.remark">{{ sts.remark }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag :color="severity(sts.status)">{{ sts.status }}</a-tag>
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>

      <a-row :gutter="{ xs: 0, lg: 16 }">
        <a-col :span="24">
          <a-card class="m-top">
            <div slot="title">
              <span class="d-block">Detail Transaksi Klaim</span>
            </div>

            <a-table :columns="approval_action ? columns : columns_view" :data-source="manifest_dtl" bordered
              style="margin-top: 10px; flex: 1; height: 100%;" :pagination="pagination"
              :scroll="widthScreen < 400 ? { x: 1200, y: 500 } : { x: 1200 }" :loading="loading.table" size="small"
              key="tblMember" :rowKey="(record, index) => index">
              <template slot="no" slot-scope="value, item, index">{{ index + 1 }}</template>
              <template slot="tgl_invoice" slot-scope="value, item, index">{{ item.tgl_invoice }}</template>
              <template slot="deskripsi" slot-scope="value, item, index">{{ item.deskripsi }}</template>
              <template slot="nilai_klaim" slot-scope="value, item, index">{{ formatRupiah(Number(item.nilai_klaim))
              }}</template>
              <!-- <template slot="dokumen" slot-scope="value, item, index">
                <a-button v-if="item.path" icon="eye" @click="viewDoc(item)">View</a-button>
                <span v-else>-</span>
              </template> -->
              <template slot="jns_plafon" slot-scope="value, item, index">{{ item.category_plafon ? item.category_plafon
                : '-' }}</template>
              <template slot="nilai_klaim_bayar" slot-scope="value, item, index">{{
                formatRupiah(Number(item.nilai_klaim_appr)) }}</template>
              <template slot="note" slot-scope="value, item, index">{{ item.note }}</template>
              <template slot="action" slot-scope="value, item, index">
                <a-button icon="form" :type="item.jenis_layanan ? 'primary' : 'danger'" shape="circle"
                  @click="editTransaction(item)"></a-button>
              </template>

            </a-table>

            <a-modal :key="stateEdit.modal_key" destroyOnClose v-model="stateEdit.edit_mode"
              title="Edit Transaksi Klaim" @cancel="cancelForm">
              <a-row :gutter="8">
                <a-col :span="12">
                  <div>
                    <span class="list-title" for>Nilai Klaim</span>
                    <span class="list-desc">{{ formatRupiah(Number(stateEdit.edit_data.nilai_klaim)) }}</span>
                  </div>
                  <div class="m-top-10">
                    <span class="list-title" for>Deskripsi</span>
                    <span class="list-desc">{{ stateEdit.edit_data.deskripsi ? stateEdit.edit_data.deskripsi : '-'
                    }}</span>
                  </div>

                </a-col>

                <a-col :span="12">
                  <div>
                    <span class="list-title" for>Sisa Saldo</span>
                    <a-input-number id="inputNumber" :min="0" disabled :formatter="rupiahFormatter"
                      :parser="rupiahParser" class="w-full" v-model:value="saldo_view" />
                  </div>
                  <!-- <div>
                    <span class="list-title" for>Dokumen Pendukung</span>
                    <a-button icon="eye" @click="viewDoc(stateEdit.edit_data)">
                      View
                    </a-button>
                  </div> -->
                </a-col>
              </a-row>
              <a-divider></a-divider>

              <a-form class="m-form" :form="form">
                <a-row :gutter="8">
                  <a-col :xs="24" :lg="12">
                    <a-form-item label="Jenis Layanan">
                      <a-select @change="onChangeSelectType" v-decorator="[
                        'jenis_layanan',
                        { rules: [{ required: true, message: 'Jenis layanan is required!' }] }
                      ]">
                        <a-select-option v-for="c in option_combo" :key="c.id_option" :value="c.id_option">{{ c.name
                        }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>

                  <!-- <a-col :xs="24" :lg="12">
                    <a-form-item label="Sisa Plafon">
                      <a-input-number id="inputNumber" :min="0"
                      disabled
                      :formatter="rupiahFormatter"
                      :parser="rupiahParser"
                      class="w-full" 
                        v-decorator="[
                            'sisa_plafon'
                        ]"
                      />
                    </a-form-item>
                  </a-col> -->

                  <a-col :xs="24" :lg="12">
                    <a-form-item :label="'Nilai Approved ' + `(${plafonState.persentase}%)`">
                      <a-input-number id="inputNumber" :min="0"  :formatter="rupiahFormatter"
                        :parser="rupiahParser" string-mode class="w-full" v-decorator="[
                          'nilai_approved',
                          {
                            rules: [
                              { required: true, message: 'Nilai approved is required!' },
                              { validator: checkMax }
                            ]
                          }
                        ]" />
                    </a-form-item>
                  </a-col>

                  <a-col :span="24">
                    <a-form-item label="Catatan">
                      <a-textarea :auto-size="{ minRows: 3, maxRows: 5 }" v-decorator="['note', {
                        rules: [{
                          required: true,
                          message: 'Catatan is required!'
                        }],
                      }]" />
                    </a-form-item>
                  </a-col>

                  <!-- <a-col :xs="24" :lg="12">
                    <a-form-item label="Perhitungan Sisa Plafon">
                      <a-input-number id="inputNumber" :min="0"
                      disabled
                      :formatter="rupiahFormatter"
                      :parser="rupiahParser"
                      class="w-full" 
                        v-decorator="[
                            'hitung_sisa_plafon'
                        ]"
                      />
                    </a-form-item>
                  </a-col> -->

                </a-row>
              </a-form>
              <template slot="footer">
                <div class="cta-section">
                  <a-button @click="cancelForm">Cancel</a-button>
                  <a-button :loading="loading.edit" type="primary" icon="save" @click="submitAction">Submit</a-button>
                </div>
              </template>
            </a-modal>

          </a-card>
        </a-col>

        <a-col :span="24" v-if="approval_action">
          <a-card class="m-top" v-if="getAuth.divisi[0] == 'HRD'">
            <div slot="title">
              <span class="d-block">Approval Klaim Kesehatan</span>
            </div>
            <a-form class="m-form" :form="form_approval">
              <a-row :gutter="8">
                <a-col :span="24">
                  <a-form-item label="Aksi">
                    <a-select v-decorator="[
                      'action',
                      { rules: [{ required: true, message: 'Aksi is required!' }] }
                    ]">
                      <a-select-option v-for="c in action_cta" :key="c.aksi" :value="c.aksi">{{ c.aksi
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :span="24">
                  <a-form-item label="Catatan">
                    <a-textarea :auto-size="{ minRows: 3, maxRows: 5 }" v-decorator="['note', {
                      rules: [{
                        required: true,
                        message: 'Catatan is required!'
                      }],
                    }]" />
                  </a-form-item>
                </a-col>

                <a-col :span="24" class="m-top-10">
                  <a-button :loading="loading.submit" icon="save" type="primary" class="w-full"
                    @click="submitApproval">Submit</a-button>
                </a-col>
              </a-row>
            </a-form>
          </a-card>
        </a-col>

      </a-row>
    </a-spin>

    <a-modal v-model="history_visible" :footer="null">
      <span slot="title">
        <a-icon type="history" />&nbsp;History Status
      </span>

      <ul class="list-wrapper bordered">
        <li v-for="history in history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="d-flex justify-between">
              <h3 class="m-remove list-title">{{ history.as_from }} | {{ history.tlc_from }}</h3>
              <H-Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="d-flex justify-between">
              <h3 class="m-remove list-title"
                v-if="(history.aksi === '4' && history.deskripsi === 'Edited') || history.deskripsi === 'Revised'">
                {{ history.as_from }} | {{ history.tlc_from }}</h3>
              <h3 class="m-remove list-title" v-else>{{ history.as_to }} | {{ history.tlc_to }}</h3>
              <H-Status :status="history.deskripsi" />
            </div>
            <span class="list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>

  </a-layout-content>
</template>

<script>
import { mapGetters } from "vuex";
import moment, { max } from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Status from "@/components/Status.vue";

const columns = [
  {
    title: 'No',
    width: 40,
    className: 'center',
    scopedSlots: { customRender: 'no' },
  },
  {
    title: 'Tanggal',
    dataIndex: 'tgl_invoice',
    scopedSlots: { customRender: 'tgl_invoice' },
  },
  {
    title: 'Deskripsi',
    dataIndex: 'deskripsi',
    scopedSlots: { customRender: 'deskripsi' },
  },
  {
    title: 'Nilai Klaim',
    dataIndex: 'nilai_klaim',
    className: 'center',
    scopedSlots: { customRender: 'nilai_klaim' },
  },
  // {
  //   title: 'Dokumen',
  //   className: 'center',
  //   dataIndex: 'dokumen',
  //   scopedSlots: { customRender: 'dokumen' },
  // },
  {
    title: 'Kategori Plafon',
    className: 'center',
    dataIndex: 'jns_plafon',
    scopedSlots: { customRender: 'jns_plafon' },
  },
  {
    title: 'Klaim Bayar',
    dataIndex: 'nilai_klaim_bayar',
    className: 'center',
    scopedSlots: { customRender: 'nilai_klaim_bayar' },
  },
  {
    title: 'Catatan',
    dataIndex: 'note',
    scopedSlots: { customRender: 'note' },
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'center',
    scopedSlots: { customRender: 'action' },
  },
];

const columns_view = [
  {
    title: 'No',
    width: 40,
    className: 'center',
    scopedSlots: { customRender: 'no' },
  },
  {
    title: 'Tanggal',
    dataIndex: 'tgl_invoice',
    scopedSlots: { customRender: 'tgl_invoice' },
  },
  {
    title: 'Deskripsi',
    dataIndex: 'deskripsi',
    scopedSlots: { customRender: 'deskripsi' },
  },
  {
    title: 'Nilai Klaim',
    dataIndex: 'nilai_klaim',
    className: 'center',
    scopedSlots: { customRender: 'nilai_klaim' },
  },
  {
    title: 'Dokumen',
    className: 'center',
    dataIndex: 'dokumen',
    scopedSlots: { customRender: 'dokumen' },
  },
  {
    title: 'Kategori Plafon',
    className: 'center',
    dataIndex: 'jns_plafon',
    scopedSlots: { customRender: 'jns_plafon' },
  },
  {
    title: 'Klaim Bayar',
    dataIndex: 'nilai_klaim_bayar',
    className: 'center',
    scopedSlots: { customRender: 'nilai_klaim_bayar' },
  },
  {
    title: 'Catatan',
    dataIndex: 'note',
    scopedSlots: { customRender: 'note' },
  },
];

export default {
  mixins: [CurrencyFormat],
  props: ["id"],
  components: {
    "H-Status": Status
  },
  data() {
    return {
      param_id: '',
      moment,
      columns,
      columns_view,
      manifest_data: [],
      manifest_hdr: {},
      manifest_dtl: [],
      manifest_status: [],
      history: [],
      history_visible: false,
      action_cta: [],
      approval_action: false,
      revise_action: false,
      pagination: {},
      loading: {
        page: false,
        edit: false,
        submit: false,
        table: false,
        print: false
      },
      stateEdit: {
        id: '',
        edit_mode: false,
        edit_data: {},
        saldo: 0,
        modal_key: 0
      },
      option_combo: [],
      plafonState: {
        rawat_jalan: 0,
        sisa_rawat_jalan: 0,
        rawat_gigi: 0,
        sisa_rawat_gigi: 0,
        p_normal: 0,
        sisa_p_normal: 0,
        p_cesar: 0,
        sisa_p_cesar: 0,
        p_keguguran: 0,
        sisa_p_keguguran: 0,
        persentase: 0
      },
      saldo: [],
      temp_saldo: [],
      saldo_final: [],
      max_input: 0,
      widthScreen: 0,
      heighScreen: 0,
      saldo_view: 0,
      jenis_layanan_view: null
    }
  },

  computed: {
    ...mapGetters([
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate"
    ]),
    rowStyle() {
      return this.widthScreen >= 992 ? { display: "flex", alignItems: "stretch" } : { display: "block" }
    }
  },

  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.form_approval = this.$form.createForm(this);
  },

  created() {
    this.param_id = this.id
  },

  watch: {

    $route(to, from) {
      if (to.name == 'manifestKlaim') {
        this.param_id = this.id
        this.stateEdit.edit_mode = false
        this.fetchData();
        this.fetchCombo();
      }
    }

  },

  mounted() {
    this.widthScreen = window.innerWidth
    this.heighScreen = window.innerHeight
    this.fetchData();
    this.fetchCombo();
  },

  methods: {
    async fetchData() {
      this.loading.page = true
      const payload = {
        manifest_id: this.param_id
      }
      try {
        const response = await this.asyncAxiosGet("klaim_kesehatan/manifest", this.getAuth, payload);
        console.log(response);
        this.manifest_hdr = response.hdr
        this.manifest_dtl = response.detail
        this.manifest_status = response.klaim_sts
        this.history = response.history_sts
        this.action_cta = response.action
        this.saldo = response.saldo
        this.temp_saldo = response.saldo
        this.approval_action = response.allow_action
        this.revise_action = response.allow_revice
        this.loading.page = false
      } catch (error) {
        this.loading.page = false
        console.log(error);
        this.displayMessageValue("error-basic", error);
      }
    },

    async fetchCombo() {
      try {
        const payload = {
          id_klaim_hdr: this.param_id
        }

        const response = await this.asyncAxiosGet("klaim_kesehatan/plafon_combo", this.getAuth, payload);
        this.option_combo = response.data.combo

      } catch (error) {
        console.log(error);
      }
    },

    editTransaction(val) {
      this.stateEdit.id = val.id_klaim_kesehatan_dtl
      this.stateEdit.edit_mode = true
      this.stateEdit.edit_data = val
      this.plafonState.persentase = 0
      console.log(val.jenis_layanan);
      if (val.jenis_layanan) {
        this.$nextTick(() => {
          this.form.setFieldsValue({
            jenis_layanan: val.jenis_layanan,
            note: val.note
          })
          this.onChangeSelectType(val.jenis_layanan) // panggil manual
        })
      } else {
        this.saldo_view = 0
      }

    },

    handleChange(value) {
      if (Number(value) > this.max_input) {
        this.$message.warning(`Maksimal input adalah ${this.max_input}`);
        this.form.setFieldsValue({ nilai_approved: this.max_input });
      }
    },

    checkMax(rule, value, callback) {
      // if (value && Number(value) > this.max_input) {
      //   callback(`Nilai tidak boleh lebih dari ${this.formatRupiah(this.max_input)}`);
      // } else {
      //   callback();
      // }
      callback();
    },

    cancelForm() {
      this.stateEdit.edit_mode = false
      this.plafonState.persentase = 0
      this.stateEdit.modal_key++;
    },

    onChangeSelectType(val) {
      const item = this.option_combo.find((d) => d.id_option == val)


      this.plafonState.persentase = item.persentase

      let persen = Number(item.persentase)
      let nilai = Number(item.nilai)

      console.log(this.saldo);
      if (item.id_option == 'Rawat Inap') {
        let nilai_aprove = (persen / 100) * Number(this.stateEdit.edit_data.nilai_klaim)
        this.max_input = Number(nilai_aprove);
        this.saldo_view = nilai_aprove
        return this.form.setFieldsValue({
          nilai_approved: nilai_aprove
        })
      } else {
        const balance = this.saldo.find((e) => e.id_plafon_member == val)
        console.log(balance);

        let nilai_aprove = (persen / 100) * Number(this.stateEdit.edit_data.nilai_klaim)
        let sisa_saldo = balance.remaining_plafon
        if (this.stateEdit.edit_data.jenis_layanan && this.stateEdit.edit_data.jenis_layanan == val) {
          sisa_saldo = Number(balance.remaining_plafon) + this.stateEdit.edit_data.nilai_klaim_appr
        }

        if (nilai_aprove > sisa_saldo) {
          nilai_aprove = sisa_saldo
        } else if (sisa_saldo == 0) {
          nilai_aprove = sisa_saldo
        }

        // let hitung_saldo = sisa_saldo - nilai_aprove;
        this.saldo_view = sisa_saldo
        this.max_input = Number(nilai_aprove);
        return this.form.setFieldsValue({
          nilai_approved: nilai_aprove
        })
        // this.form.setFieldsValue({
        //   nilai_approved: nilai_aprove,
        //   sisa_plafon: sisa_saldo,
        //   hitung_sisa_plafon: hitung_saldo
        // })
      }
    },

    rupiahFormatter(value) {
      if (value === undefined || value === null || value === '') return ''
      // pastikan value = number/string
      const parts = String(value).split('.')
      const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      const decPart = parts[1] ? ',' + parts[1] : ''
      return `Rp ${intPart}${decPart}`
    },

    rupiahParser(value) {
      if (!value) return ''
      return value
        .replace(/Rp\s?/g, '') // buang Rp
        .replace(/\./g, '')    // buang thousand separator
        .replace(',', '.')     // koma -> titik
    },

    viewDoc(val) {
      if (!val.path) return

      const ext = val.path.split('.').pop().toLowerCase()
      const imageExt = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg']

      if (imageExt.includes(ext)) {
        const img = new Image()
        img.src = this.$serviceUrl + val.path
        const newWindow = window.open("")
        newWindow.document.write(img.outerHTML)
      } else {
        const link = document.createElement('a')
        link.href = this.$serviceUrl + val.path
        link.download = val.nama_file
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
    },

    submitDetail() {
      this.loading.edit = true
      this.form.validateFields(async (err, values) => {
        console.log(values);

        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        const item = this.option_combo.find((d) => d.id_option == values.jenis_layanan)

        try {
          const payload = {
            id_klaim_hdr: this.manifest_hdr.id_klaim_kesehatan_hdr,
            id_klaim_dtl: this.stateEdit.id,
            jenis_layanan: values.jenis_layanan,
            nilai_approved: values.nilai_approved,
            used_saldo: item.used_saldo,
            sisa_plafon: (Number(values.sisa_plafon) + Number(this.stateEdit.edit_data.nilai_klaim_appr)) - Number(values.nilai_approved)
          }

          const response = await this.asyncAxiosPut("klaim_kesehatan/edit_detail_klaim", "json", this.getAuth, payload);
          this.manifest_hdr = response.hdr;
          this.manifest_dtl = response.detail;
          this.saldo = response.saldo
          // this.fetchData();
          this.displayMessage("success-save");
          this.stateEdit.edit_mode = false
          this.loading.edit = false
        } catch (error) {
          console.log(error);
          this.loading.edit = false
        }
      })
    },

    submitAction() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        try {
          const item = this.manifest_dtl.find((a) => this.stateEdit.id == a.id_klaim_kesehatan_dtl)
          let category_plafon = ''
          if (this.stateEdit.edit_data.jenis_layanan && this.stateEdit.edit_data.jenis_layanan == values.jenis_layanan) {
            console.log('sudah ada, data sama');

            if (values.jenis_layanan != "Rawat Inap") {
              const balance = this.saldo.find((a) => a.id_plafon_member == values.jenis_layanan)
              let new_saldo = Number(balance.remaining_plafon) + Number(this.stateEdit.edit_data.nilai_klaim_appr)
              balance.remaining_plafon = new_saldo - Number(values.nilai_approved)
              category_plafon = balance.jns_plafon
            } else {
              category_plafon = values.jenis_layanan
            }

          } else if (this.stateEdit.edit_data.jenis_layanan && this.stateEdit.edit_data.jenis_layanan !== values.jenis_layanan) {
            console.log('sudah ada, tapi diubah');

            if (values.jenis_layanan != "Rawat Inap") {
              const balance = this.saldo.find((a) => a.id_plafon_member == this.stateEdit.edit_data.jenis_layanan)
              let new_saldo = Number(balance.remaining_plafon) + Number(this.stateEdit.edit_data.nilai_klaim_appr)
              balance.remaining_plafon = new_saldo

              const balance2 = this.saldo.find((a) => a.id_plafon_member == values.jenis_layanan)
              balance2.remaining_plafon = Number(balance2.remaining_plafon) - Number(values.nilai_approved)
              category_plafon = balance2.jns_plafon
            } else {
              category_plafon = values.jenis_layanan
            }
          }

          if (this.stateEdit.edit_data.jenis_layanan == null) {
            console.log('Data fresh');
            if (values.jenis_layanan != "Rawat Inap") {
              const balance = this.saldo.find((a) => a.id_plafon_member == values.jenis_layanan)
              balance.remaining_plafon = Number(balance.remaining_plafon) - Number(values.nilai_approved)
              category_plafon = balance.jns_plafon
            } else {
              category_plafon = values.jenis_layanan
            }
          }

          item.nilai_klaim_appr = values.nilai_approved
          item.jenis_layanan = values.jenis_layanan
          item.note = values.note
          item.category_plafon = category_plafon

          this.displayMessage("success-save");
          this.stateEdit.edit_mode = false
        } catch (error) {
          this.displayMessage("error-basic");
        }
      })
    },

    submitApproval() {
      this.loading.submit = true
      this.form_approval.validateFields(async (err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          this.loading.submit = false
          return;
        }

        if (values.action == 'Approved') {
          for (let index = 0; index < this.manifest_dtl.length; index++) {
            if (this.manifest_dtl[index].jenis_layanan == null) {
              this.displayMessageValue('error-basic', 'Mohon sesuaikan transaksi klaim terlebih dahulu');
              this.loading.submit = false
              return
            }
          }
        }

        const payload = {
          id_klaim_hdr: this.manifest_hdr.id_klaim_kesehatan_hdr,
          details: JSON.stringify(this.manifest_dtl),
          saldo: JSON.stringify(this.saldo),
          action: values.action,
          note: values.note
        }

        try {
          const response = await this.asyncAxiosPost('klaim_kesehatan/approval', 'json', this.getAuth, payload)
          console.log(response);
          this.fetchData()
          this.displayMessageValue("success-basic", "Manifest approval success");
          this.loading.submit = false
          this.$router.go(0);
        } catch (error) {
          this.displayMessage("error-basic");
          this.loading.submit = false
        }
      })
    },

    severity(status) {
      if (status == 'Delivered') {
        return 'blue'
      } else if (status == 'Revised' || status == 'Rejected') {
        return 'red'
      } else if (status == 'Approved') {
        return 'green'
      } else {
        return 'orange'
      }
    },

    showHistory() {
      this.history_visible = true
    },

    async handlePrint() {
      this.loading.print = true
      try {
        const payload = {
          id_manifest: this.id
        }
        const response = await this.asyncAxiosFile('klaim_kesehatan/print_klaim', this.getAuth, JSON.stringify(payload))
        let blob = new Blob([response.data], { type: "application/pdf" }),
          url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
        this.loading.print = false
      } catch (error) {
        console.log(error);
        this.loading.print = false
      }
    },

    reviseAction() {
      this.$router.push({
        name: "reviseKlaim",
        params: { id: this.param_id },
      });
    }

  }
}
</script>

<style>
.demo-loadmore-list {
  min-height: 350px;
}

.m-top-10 {
  margin-top: 10px;
}

.cta-section {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.stretch-row {
  display: flex;
}

@media (min-width: 992px) {
  .stretch-row {
    display: flex;
    align-items: stretch;
  }

  .h-full {
    height: 100%;
  }
}
</style>